export default __webpack_public_path__ + "4919412ec401af03a323ea5b4085d1e8.png";